/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Singbergschule2Inputs */

const en__field__enum_schoolname_singbergschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Singbergschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wölfersheim`)
};

const de__field__enum_schoolname_singbergschule2 = /** @type {(inputs: _Field__Enum_Schoolname_Singbergschule2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Singbergschule`)
};

/**
* | output |
* | --- |
* | "Wölfersheim" |
*
* @param {_Field__Enum_Schoolname_Singbergschule2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_singbergschule2 = /** @type {((inputs?: _Field__Enum_Schoolname_Singbergschule2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Singbergschule2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_singbergschule2(inputs)
	return de__field__enum_schoolname_singbergschule2(inputs)
});
export { _field__enum_schoolname_singbergschule2 as "_field__enum_schoolName_Singbergschule" }